import React from 'react';
import moment from 'moment';
/**
 * Style.
 */
import './footer.scss';

const Footer = () => (
  <div className="footer">
    <div className="footer-links">
      <div className="footer-link"><a target="_blank" rel="noopener noreferrer" href="https://www.amorc.org.br/">PORTAL ROSACRUZ</a></div>
      <div className="footer-link"><a target="_blank" rel="noopener noreferrer" href="https://www.amorc.org.br/perguntas-frequentes/">FAQ</a></div>
      <div className="footer-link"><a target="_blank" rel="noopener noreferrer" href="https://www.amorc.org.br/organismos-afiliados/">NÚCLEOS ROSACRUZES</a></div>
      <div className="footer-link"><a target="_blank" rel="noopener noreferrer" href="http://atendimento.amorc.org.br/open.php">ATENDIMENTO</a></div>
    </div>
    <div className="footer-copyright">
      © Razão Social: Antiga E Mística Ordem Rosae Crucis AMORC GLJL PORTUGUESA
      | CNPJ: 76.565.720/0001-66 - [
      {moment().format('Y')}
      ]
      <br />
      <br />
      Rua Nicarágua, 2620 - Bacacheri - 82515-260 - Curitiba - PR - Brasil
      <br />
      Tel: (41) 3351-3000 -
      {' '}
      Whatsapp: (41) 99843-2700 -
      {' '}
      <a href="mailto:atendimento@amorc.org.br">atendimento@amorc.org.br</a>
    </div>
  </div>
);

export default Footer;
